<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>消费单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="align-items: flex-start;display: flex;justify-content: flex-start;justify-items: center">
      <el-button size="mini" plain @click="showCustomerDialog"
                 v-if="authorities.includes('sales.order.new.card')">新建档案</el-button>
      <el-button size="mini" plain @click="showHyOrderDialog" style="margin-left: 5px;"
                 v-if="authorities.includes('sales.order.new')">新建会员订单</el-button>
      <el-button size="mini" plain @click="showSkOrderDialog" style="margin-left: 5px;"
                 v-if="authorities.includes('sales.order.new')">新建散客订单</el-button>
      <el-input size="mini" placeholder="请输入姓名或手机号进行搜索"
                v-model="orderRequest.queryOrderText"
                @keyup.enter.native="queryOrder1"
                @blur="queryOrder1"
                style="width: 170px;padding-bottom: 5px;margin-left: 5px;margin-right: 5px"></el-input>
      <el-date-picker
        v-model="orderRequest.selectDate"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectKpiData"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-select value filterable v-model="selectAreaId" v-if="orgLevel === 1" placeholder="请选择区域" clearable
                 style="margin-left: 5px;width: 200px" size="mini" @change="getArea">
        <el-option
          v-for="item in area"
          :key="item.id"
          :label="item.orgName"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-if="orgLevel < 3" v-model="selectOrgId" clearable value filterable placeholder="请选择门店"
                 style="margin-left: 5px;width: 200px" size="mini" @change="getShop">
        <el-option
          v-for="org in shop"
          :key="org.id"
          :label="org.orgName"
          :value="org.id">
        </el-option>
      </el-select>
      <el-button size="mini"  style="margin-left: 5px;" @click="queryOrder">查询</el-button>
    </div>

      <span v-if="orgLevel == 3" v-for="item in orderPayTypeTotalMoney" style="color: #3a8ee6;font-size: 13px;margin-right: 20px">
        {{item.payCnName}}:{{item.money}}
      </span>
      <el-table height="590px" :data="orderList" fit border stripe="stripe"
                :header-cell-style="{background:'#eff3f8', color:'#333', fontWeight:700}"
                :cell-style="orderStateColor"
                :row-style="{height: '0'}"
                >
        <el-table-column
          align="center"
          prop="userName"
          fixed="fixed"
          label="操作" width="140"
        >
          <template slot-scope="scope">
            <div style="display: flex;justify-content: space-evenly">
              <el-link type="primary"
                       @click="showOrderDetailDialog(scope.row)">查看</el-link>
              <el-link type="primary"
                       :disabled="scope.row.isSubmit === 1 || scope.row.state === 4"
                       v-if="authorities.includes('sales.order.update.yizhi')"
                       @click="showUpdateOrderDialog(scope.row)">修改</el-link>
              <el-link type="primary"
                       :disabled="nowDate !== scope.row.orderDateStr || scope.row.state === 4"
                       v-if="authorities.includes('sales.order.update.today')"
                       @click="showUpdateOrderDialog(scope.row)">修改</el-link>
             <div v-if="authorities.includes('sales.order.cancel.yizhi')">
                <el-link
                  v-if="authorities.includes('sales.order.cancel.yizhi')"
                  type="primary" :disabled="scope.row.state === 4 || scope.row.state === 2 || scope.row.state === 3"
                          @click="isCancelOrder(scope.row)">作废</el-link>
             </div>
             <div v-if="authorities.includes('sales.order.cancel.dangyue')">
                <el-link
                  v-if="authorities.includes('sales.order.cancel.dangyue')"
                  type="danger" :disabled="scope.row.state === 4 || scope.row.state === 2
                        || nowDate !== scope.row.orderDateStr || scope.row.state === 3 "
                          @click="isCancelOrder(scope.row)">作废</el-link>
             </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="会员/散客" width="100">
          <template slot-scope="scope">
            <el-link type="primary" :disabled="scope.row.customerName === '散客'"
                     @click.prevent="toDetail(scope.row.customerId)" >{{scope.row.customerName}}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderDate"
          :formatter="dateFormatter"
          label="消费日期" width="170">
        </el-table-column>
        <el-table-column
          align="center"
          prop="state"
          :formatter="stateFormatter"
          label="状态" >
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderReceivable"
          label="应收金额" >
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderDiscounts"
          label="优惠金额" >
        </el-table-column>
        <el-table-column
          align="center"
          prop="moLing"
          label="抹零金额" >
        </el-table-column>
        <el-table-column
          align="center"
          prop="couZheng"
          label="凑整金额" >
        </el-table-column>
        <el-table-column
          align="center"
          label="欠款金额" >
          <template slot-scope="scope">
            <span v-if="scope.row.isHk === 1" style="color: #0CB618">{{scope.row.arrearageMoney}}</span>
            <span v-if="scope.row.isHk === 2" style="color: #EA1B28">{{scope.row.arrearageMoney}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderReceived"
          label="实收金额" >
        </el-table-column>
        <el-table-column
          align="center"
          prop="payType"
          label="支付方式" width="200">
        </el-table-column>
        <el-table-column
          align="center"
          prop="refundMoney"
          label="退费金额" >
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderOrgName"
          label="消费门店" width="200">
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderNo"
          label="消费单号" width="200">
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间"
          width="180">
        </el-table-column>
        <el-table-column
          align="center"
          prop="modifyTime"
          label="最后操作时间"
          width="180">
        </el-table-column>
        <el-table-column
          align="center"
          prop="modifierName"
          label="最后操作人"
          width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="isSubmit"
          label="连通用友"
          :formatter="submitFormatter"
          width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="id"
          label="消费单id"
          width="80">
        </el-table-column>
        <el-table-column
          align="center"
          label="备注说明"
          width="250">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.comment }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="mini">{{ scope.row.comment }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>

    <!-- 订单详情窗口-->
    <el-dialog
      title="消费单详情"
      :visible.sync="orderDetailDialogVisible"
      width="60%"
      @close="closeOrderDetailDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-between;">
          <div>
            <span>订单日期：</span>
            <el-date-picker
              v-model="value1"
              type="datetime"
              size="mini"
              readonly
              placeholder="订单日期"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </div>
          <div>
            <span>所属门店：</span>
            <el-input v-model="orderDetail.orderOrgName" readonly size="mini" style="width: 150px"></el-input>
          </div>
          <div>
            <span>订单编号：</span>
            <el-input v-model="orderDetail.orderNo" readonly size="mini" style="width: 200px"></el-input>
          </div>
          <div>
            <span>消费人次：</span>
            <el-input v-model="orderDetail.peoples" readonly size="mini" style="width: 200px"></el-input>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" v-if="updateCustomerCard != null">
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">卡别名称：</span>
              <el-input v-model="updateCustomerCard.cardTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">所属门店：</span>
              <el-input v-model="updateCustomerCard.shopName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 20%">会员等级：</span>
              <el-input v-model="updateCustomerCard.cardLevelName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">适用项目：</span>
              <el-input v-model="updateCustomerCard.useTypeName" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
               v-if="updateCustomerCard.cardType < 3">
            <div style="width: 50%">
              <span style="width: 20%">账户余额：</span>
              <el-input v-model="updateCustomerCard.balance" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">卡有效期：</span>
              <el-input v-model="updateCustomerCard.validDate" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div v-if="updateCustomerCard.cardType === 2">
            <div style="width: 50%" >
              <span style="width: 20%">赠送金额：</span>
              <el-input v-model="updateCustomerCard.giveBalance" readonly size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
               v-if="updateCustomerCard.cardType === 3">
            <div style="width: 50%">
              <span style="width: 20%">可用次数：</span>
              <el-input v-model="updateCustomerCard.cardNum" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 20%">卡有效期：</span>
              <el-input v-model="updateCustomerCard.validDate" readonly
                        size="mini" style="width: 70%;"></el-input>
            </div>
          </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <el-table :data="orderDetailList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#000000'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            prop="refundNum"
            label="退货数量" width="160">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.refundNum" size="mini" :precision="0"
                               :disabled="scope.row.detailState === 2 || tuihuoClick === true"
                               @change="refundCheck(scope.row, scope.row.refundNum)" :min="0" :max="refundMaxNum" ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="detailState"
            :formatter="orderDetailStateFormatter"
            label="订单状态" >
          </el-table-column>
          <el-table-column
            align="center"
            label="寄存总数量"
            prop="storeTotalNum"
            width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="storeNum"
            label="现存数量" width="160">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.storeNum" :precision="0"
                               :disabled="isCustomerOrder === false || scope.row.type === 1 || scope.row.isStore === 1 || (scope.row.num - scope.row.refundNum) <= 0"
                               size="mini" @change="setStoreProduct(scope.row, scope.row.storeNum)"
                               :min="0" :max="storeMaxNum" />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :formatter="storeProductFormatter"
            label="寄存状态" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="consumptionName"
            label="项目名称" width="200">
          </el-table-column>
          <el-table-column
            align="center"
            prop="dia"
            label="直径" width="160"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="num"
            label="数量" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            label="标准价格" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="vipPrice"
            label="会员价格" v-if="isCustomerOrder === true">
          </el-table-column>
          <el-table-column
            align="center"
            label="金额小计">
            <template slot-scope="scope">
              {{ (scope.row.received - scope.row.giveBalancePay).toFixed(2)}}
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <div style="display: flex;justify-content: space-between;align-items:center;width: 100%;">
          <div>
            <span >应收金额：</span>
            <el-input v-model="orderDetail.orderReceivable" readonly  placeholder="请输入内容"  size="mini" style="width: 60%;"/>
          </div>
          <div v-if="isCustomerOrder === true">
            <span style="width: 10%;margin-left: 5px;" >会员优惠：</span>
            <el-input v-model="orderDetail.orderDiscounts" readonly  placeholder="请输入内容" size="mini" style="width: 60%;"/>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">抹零金额：</span>
            <el-input v-model="orderDetail.moLing"  readonly  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">凑整金额：</span>
            <el-input v-model="orderDetail.couZheng"  readonly  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
          <div v-if="orderDetail.isArr === 1">
            <span style="width: 10%;margin-left: 5px;">欠款金额：</span>
            <el-input v-model="orderDetail.arrearageMoney"  readonly  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;"> 实收金额：</span>
            <el-input v-model="orderDetail.orderReceived" readonly  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <el-table :data="selectServerList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}"
                  style="margin-top: 5px">
          <el-table-column
            align="center"
            prop="userName"
            label="服务人员">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机">
          </el-table-column>
          <el-table-column
            align="center"
            prop="rate"
            label="提成比例">
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <div  style="width:100%;">
          <div style="width:75px;">支付方式：</div>
          <div  v-for="(item, index) in orderPayTypeList" :key="index" style="display: inline-block; width: 25%;margin-top: 10px" >
            <span style="display: inline-block; width: 80px;text-align: right"> {{item.payCnName}}:</span>
            <el-input v-model="item.money"
                      placeholder="请输入内容" size="mini" style="width: 100px;margin-right: 10px;"
                      readonly
            ></el-input>
            <br>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" v-if="updateTicket != null" style="margin-top: 10px">
        <div  style="width:100%;">
          <div style="width:75px;">优惠券：</div>
          {{updateTicket.title}}{{updateTicket.consumptionName}}
        </div>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeOrderDetailDialog">确 定</el-button>
        <el-button size="mini" :disabled="refundClick" @click="isFundOrder">退 费</el-button>
        <el-button size="mini" :disabled="storeClick" @click="showStockProductDialog">寄 存</el-button>
      </span>
    </el-dialog>


    <!-- 消费单退费窗口-->
    <el-dialog
      title="消费单退费"
      :visible.sync="refundOrderMoneyDialogVisible"
      width="60%"
      @close="closeRefundOrderMoneyDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-evenly;align-items:center;width: 100%;">
          <div>
            <span >应退金额：</span>
            <el-input v-model="refundOrder.receivable" disabled  size="mini" style="width: 60%;"/>
          </div>
          <div>
            <label style="color: #FA5858">*</label>
            <span style="width: 10%;">实退金额：</span>
            <el-input v-model="refundOrder.money"  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
          <div v-if="isCustomerOrder === true">
            <el-button size="mini" @click="getCheckCode">获取验证码</el-button>
            <el-input v-model="refundOrder.checkCode" placeholder="请输入验证码" size="mini" style="width: 60%;"/>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <label style="color: #FA5858">*</label>
        <span>备注说明：</span>
        <el-input v-model="refundOrder.comment"  placeholder="请输入内容" type="textarea" size="mini" style="width: 100%;" />
      </el-card>

      <span class="dialog-footer">
        <el-button size="mini" @click="closeRefundOrderMoneyDialog">取 消</el-button>
        <el-button size="mini" @click="createRefundOrder">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 产品寄存-->
    <el-dialog
      title="产品寄存"
      :visible.sync="stockProductDialogVisible"
      width="40%"
      @close="closeStockProductDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="display: flex;justify-content: space-evenly;align-items:center;width: 100%;margin-top: 10px;">
        <div>
          <el-input v-model="storeProduct.checkCode"  size="mini" style="width: 60%;"/>
          <el-button size="mini" @click="getCheckCode">验证码</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeStockProductDialog">取 消</el-button>
        <el-button size="mini" @click="createStoreProduct">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      areaId: window.sessionStorage.getItem('areaId'),
      reserveCustomerId:0,
      reserveId:0,
      reserveShopId:0,
      userId:'',
      currentOrgId:'',
      authorities:'',
      moLingRate:'',
      isHyMoLingSet:false,
      value1:'',
      isHyCouZhengSet:false,

      queryText:'',
      queryOrderText:'',
      orderList:[],
      area: [],
      shop:[],
      maxMoLingMoney:'',
      stateText:[
        {state:1, name:'已支付'},
        {state:2, name:'部分退费'},
        {state:3, name:'全部退费'},
        {state:4, name:'已作废'}
      ],
      submitText:[
        {isSubmit:1, name:'已提交'},
        {isSubmit:2, name:'未提交'},
      ],
      stateArr:{
        1:'已支付',
        2:'部分退费',
        3:'全部退费',
        4:'已作废'
      },
      orderDetail:'',
      //订单详情窗口
      orderDetailDialogVisible:false,
      orderDetailList:[],
      orderDetailStateText:[
        {detailState:1,name:'已支付'},
        {detailState:2,name:'已退费'}
      ],
      storeStateText:[
        {isStore:1,name:'已寄存'},
        {isStore:2,name:'未寄存'},
        {isStore:3,name:'已提取'},
      ],
      isBalancePay:true,
      //创建会员档案部分

      consumptionTypeFilterText:'',
      multipleSelection:[],
      selectedCustomerTicket:'',
      qiankuan: 0,  //欠款
      lsQk:'',      //临时欠款
      currentPage: 1,
      pageSize:20,
      pageTotal:0,
      serverDialogVisible:false,
      queryServerText:'',
      serverList:[],
      currentPage2: 1,
      pageSize2:20,
      pageTotal2:0,
      storeProduct:{
        productId:'',
        productTypeId:'',
        orderDetailId:'',
        productName:'',
        storeNum:'',
        orgId:'',
        orderId:'',
        type:'',
        creator:'',
        customerId:'',
        phone:'',
        orderDetails:[],
        checkCode:''
      },

      currentPage4: 1,
      pageSize4:20,
      pageTotal4:0,
      dataType:'',
      consumptionTypeId:'',
      consumptionQueryText:'',
      orgLevel:0,
      orgName:'',

      rateTotal:0,
      refundResult:false,
      storeResult:false,

      orderPayTypeList:[],
      orderPayTypeTotalMoney:[],

      refundClick:true,
      tuihuoClick:true,
      storeClick:true,
      storeMaxNum:999,
      refundMaxNum:999,
      xianjin:0,
      shishou:0,
      douyintuangou:0,
      meituantuangou:0,
      koubeituangou:0,
      xiaochengxutuangou:0,
      ciCardMoney:0,

      phoneExist:false,
      knifeExist:false,
      orderRequest:{
        selectDate:'',
        orgId: '',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:'',
        name:'',
        state:'',
        areaId:'',
        shopId:'',
        queryOrderText:''
      },
      selectOrgId:'',
      selectAreaId:'',

      refundOrderMoneyDialogVisible:false,
      refundOrder:{
        orgId:'',
        orderId:'',
        receivable:'',
        money:'',
        orderDetailList:[],
        viceName:'',
        type:'',
        customerId:'',
        serverId:'',
        phone:'',
        checkCode:'',
        openId:'',
        comment:'',
        customerCard:'',
        userId:''
      },
      stockProductDialogVisible:false,
      nowDate:'',
      nowMonth:'',
      customerRequest:{
        orgId:'',
        pageNum:'',
        pageSize:'',
        queryText:'',
        customerId:'',
      },
      updateCustomerCard:{},
      isCustomerOrder:false,
      selectServerList:[],
      consumptionRequest:{
        orgId:'',
        typeId:'',
        dateType:'',
        pageNum:'',
        pageSize:'',
        queryText:'',
        consumptionId:''
      },
      openId:'',
      updateTicket:'',
    }

  },
  methods:{
    selectKpiData(){
      if (this.orderRequest.selectDate === null){
        this.orderRequest.startDate = '';
        this.orderRequest.endDate = '';
      } else {
        this.orderRequest.startDate = this.orderRequest.selectDate[0];
        this.orderRequest.endDate = this.orderRequest.selectDate[1];
      }
    },
    queryOrder1(){
      if(this.orderRequest.queryOrderText != ''){
        this.orderRequest.startDate = '';
        this.orderRequest.endDate = '';
      }
     this.queryOrder();
    },
    async queryOrder(){
      await this.loadOrdersCount();
      await this.loadOrders();
    },
    dateFormatter(row, column) {
      // 获取单元格数据
      let data = row[column.property]
      if(data == null) {
        return null
      }
      let dt = new Date(data)
      let year = dt.getFullYear();//获取年份
      let month = dt.getMonth() + 1;//获取月份
      let day = dt.getDate();//获取日期
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      return year + '-' + month + '-' + day
    },
    stateFormatter(row){
      let value = "";
      for (let i = 0; i < this.stateText.length; i++){
        let item = this.stateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    submitFormatter(row){
      let value = "";
      for (let i = 0; i < this.submitText.length; i++){
        let item = this.submitText[i];
        if (row.isSubmit === item.isSubmit) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    // checkBalance(){
    //   if (this.order.balancePay > this.customer.balance){
    //     this.order.balancePay = this.customer.balance;
    //   }
    // },

    async loadOrdersCount(){
      this.orderRequest.pageNum = this.currentPage;
      this.orderRequest.pageSize = this.pageSize;

      if (this.selectAreaId !== ''){
        this.orderRequest.areaId  = this.selectAreaId;
      }
      if (this.selectOrgId !== ''){
        this.orderRequest.shopId = this.selectOrgId;
      }
      this.orderRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/count/order/query`, this.orderRequest)
      this.pageTotal = res.totalPage;
    },
    async loadOrders(){
      this.orderRequest.pageNum = this.currentPage;
      this.orderRequest.pageSize = this.pageSize;

      if (this.selectAreaId !== ''){
        this.orderRequest.areaId  = this.selectAreaId;
      }
      if (this.selectOrgId !== ''){
        this.orderRequest.shopId = this.selectOrgId;
      }
      this.orderRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/order/query`, this.orderRequest)
      if (res.code !== 200){
        return this.$message.error("获取订单列表失败！")
      }
      this.orderList = res.data;
    },
    toDetail(item){
      this.$router.push({path:'/card',query:{id:item}});
    },
    orderStateColor({row,columnIndex}){
      if (row.state === 1 && columnIndex ===3){
        return 'color:#0CB618';
      } else if (row.state === 4 && columnIndex ===3){
        return 'color:#EA1B28';
      } else if (row.state === 2 && columnIndex ===3){
        return 'color:#FAAC58';
      } else if (row.state === 3 && columnIndex ===3){
        return 'color:#ff1a1a';
      }
    },
    async showOrderDetailDialog(data){
      // this.updateCustomerCard = '';
      this.isCustomerOrder = data.customerId > 0;
      this.clearOrderDetail();
      this.orderDetail = data;
      this.value1 = data.orderDate;
      this.storeProduct.customerId = data.customerId;
      this.openId = data.openId;
      this.tuihuoClick = data.state === 4;
      // if (data.isArr === 2){
        const {data:res} = await this.$http.get(`/orderDetail/orderId/${data.id}`)
        this.orderDetailList = res.data;
      // }
      // if (data.isArr === 1){
      //   const {data:res} = await this.$http.get(`/arr/order/detail/${data.id}`)
      //   this.orderDetailList = res.data;
      // }
      const {data:res1} = await this.$http.get(`/order/payType/orderId/${data.id}`)
      this.orderPayTypeList = res1.data;
      const {data:res2} = await this.$http.get(`/load/one/customerCard/${data.cardId}`)
      this.updateCustomerCard = res2.data;
      if(this.updateCustomerCard != null){
        this.getCardLevelName(this.updateCustomerCard);
      }
      const {data:res3} = await this.$http.get(`/load/order/ticket/orderId/${data.id}`)
      this.updateTicket = res3.data;
      await this.loadOrderServers(data);
      this.refundClick = true;
      this.storeClick = true;
      this.orderDetailDialogVisible = true;
    },
    async loadOrderServers(data){
      const {data:res} = await this.$http.get(`/orderDetail/server/orderId/${data.id}`)
      this.selectServerList = res.data;
    },
    clearOrderDetail(){
      this.orderDetail = '';
      this.value1 = '';
      this.storeProduct.customerId='';
      this.tuihuoClick = true;
      this.orderDetailList = [];
      this.orderPayTypeList = [];
      this.selectServerList = [];
      this.updateCustomerCard = '';
    },
    async isCancelOrder(row){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/order/is/cancel`, row);
      if(res.data === true){
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return this.$message.warning("此消费单存在寄存并提取的物品，所以不能作废！")
      }
      // this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      if(row.cardId > 0){
        const {data:res1} = await this.$http.get(`/load/one/customerCard/${row.cardId}`);
        if (res1.data.validDate <= this.nowDate && res1.data.cardType === 3){
          this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
          return this.$message.error("该消费单使用次卡消费，次卡现已过期，不允许作废");
        }
      }
      //检查是否已经退费，如果已经退费了，提示已经退费，不允许退费，
      // const {data:res2} = await this.$http.post(`/check/order/state`, row);
      // if(res2.data == 1){
      //   this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      //   return this.$message.warning("该消费单已经退费，不允许作废!");
      // }
      // this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      await this.cancelOrder(row);
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
    },
    async cancelOrder(row){
      const {data:res} = await this.$http.post(`/order/cancel/${this.userId}`, row);
      if (res.code === 200){
        this.$message.success("操作成功！")
      } else {
        this.$message.warning(res.msg);
      }
      await this.loadOrders();
      await this.loadOrderPayTypeTotalMoney();
    },
    closeOrderDetailDialog(){
      this.orderDetailDialogVisible = false;
    },
    refundCheck(row){
      this.refundMaxNum = row.num;
      let flag = false;
      this.orderDetailList.map((item) => {
        if (item.refundNum > 0){
          flag = true;
          this.refundClick = false;
        }
      })
      if (flag === false){
        this.refundClick = true;
      }
    },
    async setStoreProduct(row){
      this.storeMaxNum = row.num - row.refundNum;
      let flag = false;
      this.orderDetailList.map((item) => {
        if (item.storeNum > 0){
          flag = true;
          this.storeClick = false;
        }
      })
      if (flag === false){
        this.storeClick = true;
      }
    },
    async isFundOrder(){
      let consumptionId = 0;
      this.orderDetailList.map((item) => {
        if (item.consumptionParentTypeName === '次卡'){
          consumptionId = item.consumptionId;
        }
      })
      if (consumptionId > 0){
        const {data:res} = await this.$http.get(`/load/customerCard/consumptionId/${consumptionId}`);
        if (res.data.validDate <= this.nowDate){
          return this.$message.error("次卡已过期，不允许退费");
        }
      }

      let money = 0;
      for(let i =0; i < this.orderPayTypeList.length;i++){
        if (this.orderPayTypeList[i].payEnName !== 'huiyuan' && this.orderPayTypeList[i].payEnName !== 'zengsonghuiyuan'){
          money += (this.orderPayTypeList[i].money - 0);
        }
      }
      let message = '';
      if (money > 0 || this.orderDetail.isArr === 1){
        message = '退回到现金！'
        this.refundOrder.type = 2 ;
      } else {
        message = '退回到会员！'
        this.refundOrder.type = 1;
      }
      this.$confirm(message, '退费提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.RefundOrderCheck();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退费'
        });
      });
    },
    RefundOrderCheck(){
      let result = false;
      for (let i = 0; i < this.orderDetailList.length; i++) {
        if (this.orderDetailList[i].isRefund === 2 && this.orderDetailList[i].isStore === 1 &&
            this.orderDetailList[i].refundNum > (this.orderDetailList[i].storeTotalNum - this.orderDetailList[i].getNum)){
          result = true;
        }
      }
      if (result){
        this.$confirm("该消费单的产品退费数量 > 该产品的寄存数量，是否继续退费", '退费提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.showRefundOrderMoneyDialog();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退费'
          });
        });
      } else {
        this.showRefundOrderMoneyDialog();
      }
    },
    showRefundOrderMoneyDialog(){
      this.refundOrder.money = '';
      this.refundOrder.comment = '';
      this.refundOrder.orgId = this.orderDetail.orderOrgId;
      this.refundOrder.orderId = this.orderDetail.id;
      this.refundOrder.customerId = this.orderDetail.customerId;
      this.refundOrder.serverId = this.userId;
      this.refundOrder.openId = this.openId;
      this.refundOrder.phone = this.orderDetail.phone;
      this.refundOrder.customerCard = this.updateCustomerCard;
      let yingtui = 0;
      this.orderDetailList.map((item) => {
        if (item.refundNum > 0 && item.isRefund == 2){
          if (item.isShowDia === 1){
            yingtui += item.received - item.giveBalancePay - 0;
          } else {
            yingtui += ((item.received / item.num) * item.refundNum - (item.giveBalancePay / item.num))  - 0;
          }
        }
      })
      this.refundOrder.receivable = yingtui.toFixed(2);
      this.refundOrderMoneyDialogVisible = true;
    },
    closeRefundOrderMoneyDialog(){
      this.refundOrderMoneyDialogVisible = false;
    },
    async createRefundOrder(){
      this.refundOrder.userId = this.userId;
      if (this.refundOrder.money === ''){
        return this.$message.warning("请填写退费金额！");
      }

      if (this.refundOrder.receivable -0 < this.refundOrder.money -0){
        return this.$message.warning("实退金额 > 应退金额，请核对！");
      }

      if (this.refundOrder.checkCode === '' && this.isCustomerOrder === true){
        return this.$message.warning("请输入验证码！");
      }

      if (this.refundOrder.comment === ''){
        return this.$message.warning("请填写备注信息！");
      }
      if(this.updateCustomerCard == ''){
        this.refundOrder.customerCard = null;
      }
      this.refundOrder.orderDetailList = this.orderDetailList;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post('/order/refund', this.refundOrder);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      if (res.code === 401){
        return this.$message.error("验证码无效！")
      }
      this.orderDetailList = res.data;
      this.closeRefundOrderMoneyDialog();
      this.closeOrderDetailDialog();
      await this.loadOrders();
      await this.loadOrderPayTypeTotalMoney();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
    },
    orderDetailStateFormatter(row){
      let value = "";
      for (let i = 0; i < this.orderDetailStateText.length; i++){
        let item = this.orderDetailStateText[i];
        if (row.detailState === item.detailState) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    storeProductFormatter(row){
      let value = "";
      for (let i = 0; i < this.storeStateText.length; i++){
        let item = this.storeStateText[i];
        if (row.isStore === item.isStore) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    showHyOrderDialog(){                  //会员消费单
      this.$router.push('/new/member/order')
    },

    showCustomerDialog(){
      this.$router.push('/new/member')
    },
    //寄存物品方法
    async createStoreProduct(){
      this.storeProduct.orderDetails = this.orderDetailList;
      this.storeProduct.creator = this.userId;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/order/store`, this.storeProduct)
      if (res.code === 200){
        this.$message.success("操作成功！")
        this.orderDetailList = res.data;
      }
      if (res.code === 401){
        return this.$message.error("验证码无效！")
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closeStockProductDialog();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadOrders();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadOrders();
    },

    async loadOrgPayType(){
      const {data:res} = await this.$http.get(`/payType/orgPayType/orgId/${this.currentOrgId}`)
      this.orgPayTypeList = res.data;
    },

    async loadOrderPayTypeTotalMoney(){
      const {data:res} = await this.$http.get(`/order/payTypeTotal/orgId/${this.currentOrgId}`)
      this.orderPayTypeTotalMoney = res.data;
    },

    async getArea(data){
      await this.loadShop(data);
    },
    async loadShop(areaId){
      if (areaId !== '' ){
        const {data:res} = await this.$http.get(`/orgs/area/orgId/${areaId}`);
        this.shop = res.data;
      }
      if (areaId === ''){
        this.shop = [];
        this.selectOrgId = '';
        this.orderRequest.areaId = '';
      }
    },
    getShop(data){
      this.selectOrgId = data;
      if (data === ''){
        this.orderRequest.orgId = '';
        this.orderRequest.shopId = '';
      }
    },
    async loadAreaOrgs(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.currentOrgId}`);
      if (res.code === 200){
        this.area = res.data;
      }
    },
    showUpdateOrderDialog(data){
      this.$router.push({
        path: '/edit/order',
        query: {orderId: data.id}
      });
    },
    getCardLevelName(customerCard){
      if (customerCard.cardLevel === 0){
        customerCard.cardLevelName = '普通会员';
      }
      if (customerCard.cardLevel === 1){
        customerCard.cardLevelName = '钻石会员';
      }
      if (customerCard.cardLevel === 2){
        customerCard.cardLevelName = '铂金会员';
      }
      if (customerCard.cardLevel === 3){
        customerCard.cardLevelName = '黄金会员';
      }
      if (customerCard.cardLevel === 4){
        customerCard.cardLevelName = '大众会员';
      }
    },
    async getCheckCode(){
      const {data:res} = await this.$http.get(`/users/getCode/${this.orderDetail.phone}`);
      if (res.code === 200){
        return this.$message.success("验证码已发送至您的手机");
      }
    },
    showStockProductDialog(){
      this.storeProduct.checkCode = '';
      this.storeProduct.orgId = this.orderDetail.orderOrgId;
      this.storeProduct.orderId = this.orderDetail.id;
      this.storeProduct.customerId = this.orderDetail.customerId;
      this.storeProduct.serverId = this.userId;
      this.storeProduct.phone = this.orderDetail.phone;
      this.stockProductDialogVisible = true;
    },
    closeStockProductDialog(){
      this.stockProductDialogVisible = false;
    },
    getNowDate() {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      let day = timeOne.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      this.nowDate = `${year}-${month}-${day}`
    },
    //显示新建散客订单窗口
    showSkOrderDialog(){
      this.$router.push('/new/sk/order')
    },
    //计算table高度(动态设置table高度)
    getTableHeight() {
      let tableH = 295; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
    getCurrentDate(){
      let today = new Date();
      let year = today.getFullYear();//获取年份
      let month = today.getMonth() + 1;//获取月份
      let day = today.getDate();//获取日期
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      return year + "-" + month + "-" + day;
    }
  },
  watch: {
    consumptionTypeFilterText(val) {
      this.$refs.serviceTree.filter(val);
    }
  },
  created(){
    this.reserveCustomerId = this.$route.query.customerId;
    this.reserveId = this.$route.query.reserveId;
    this.reserveShopId = this.$route.query.reserveShopId;
    if (this.reserveCustomerId > 0 && this.reserveShopId > 0){
      this.$router.push({path:'/new/member/order', query:{reserveId:this.reserveId, customerId:this.reserveCustomerId, reserveShopId: this.reserveShopId}});
    }
    if (this.reserveCustomerId == 0 && this.reserveShopId > 0 && this.reserveId > 0){
      this.showSkOrderDialog();
    }
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.moLingRate = window.sessionStorage.getItem('moLingRate');
    this.orgName = window.sessionStorage.getItem('orgName');
    if(this.orderRequest.startDate == ''){
      this.orderRequest.startDate = this.getCurrentDate();
    }
    if(this.orderRequest.endDate == ''){
      this.orderRequest.endDate = this.getCurrentDate();
    }
    this.loadOrdersCount();
    this.loadOrders();
    this.loadOrgPayType();
    this.loadOrderPayTypeTotalMoney();
    this.loadAreaOrgs();
    if (this.orgLevel > 1){
      this.loadShop(this.currentOrgId);
    }
    this.getNowDate();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Orders.vue